/* Bob v3 — guided shopping assistant (.ubb). Loaded from the footer group custom-liquid section next to ulevi-bob.css.
   Scripted, tap-to-choose helper: opens once per visit, finds the right in-stock
   product for a need, adds it to the real cart (/cart/add.js) with a quantity,
   then asks how the visitor wants to pay:
     card  → Shopify checkout;
     cash  → details form → order placed by the bob-order Edge Function (payment pending);
     bank  → TBC / BOG → details → order placed → bank details → receipt upload now / later.
   Product data comes live from /collections/shop/products.json (in-stock smart
   collection). State survives page changes through sessionStorage. The theme
   exposes window.__uBob (logged-in customer + pending bank-transfer orders). */
(function () {
  'use strict';

  var IS_EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var THRESHOLD = 9900;
  var SHIP = { tbilisi: 500, region: 800, mountain: 1300 };
  var API = 'https://kimobmzhylcxhshmnlpb.supabase.co/functions/v1/bob-order';
  var WA = 'https://wa.me/995568000303';
  var PHONE = '+995 568 00 03 03';
  var NAME = IS_EN ? 'Bob' : 'ბობი';
  var BANKS = {
    tbc: { name: 'TBC Bank', holder: 'შპს ალაგნუ', iban: 'GE71TB7326836020100004' },
    bog: { name: 'Bank of Georgia', holder: 'შპს ალაგნუ', iban: 'GE77BG0000000553392960' }
  };
  var path = location.pathname;
  if (/\/checkouts?\b|\/password|\/challenge/.test(path)) return;
  if (window.Shopify && window.Shopify.designMode) return;
  var BRIDGE = window.__uBob || { customer: null, pending: [] };

  /* ---- copy: see ulevi-bob-i18n.js ---- */
  var T = window.__uBobT ? window.__uBobT(IS_EN, NAME, PHONE, money) : null;
  if (!T) return;

  var CAT = 'კატეგორია: ';
  var NEEDS = {
    car: { handles: ['manqanis-aromatizatori', '🚗-მანქანის-სურნელები', 'wexor-sprei-usiamovno-sunistvis', 'wexor-universaluri-sprei'] },
    pets: { handles: ['wexor-iatakis-sawmendi', 'wexor-oflis-da-shardis-laqebis-mosashorebeli', 'wexor-universaluri-sprei', 'wexor-sprei-usiamovno-sunistvis', 'wexor-iatakis-universaluri-sawmendi'] },
    laundry: { tag: CAT + 'სარეცხი და ქსოვილის მოვლა', link: 'sarecxi-da-qsovilis-movla' },
    floors: { tag: CAT + 'იატაკი და ზედაპირები', link: 'iataki-da-zedapirebi' },
    kitchen: { tag: CAT + 'სამზარეულო', link: 'samzareulo' },
    home: { tag: CAT + 'არომატიზატორები', link: 'aromatizatorebi', skip: ['manqanis-aromatizatori', '🚗-მანქანის-სურნელები'] },
    best: { all: true, link: 'shop' }
  };
  var NEED_ORDER = ['car', 'pets', 'laundry', 'floors', 'kitchen', 'home', 'best'];

  /* ---- utils ---- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(tetri) { return (tetri / 100).toFixed(2) + ' ₾'; }
  function items(n) { return IS_EN ? (n === 1 ? '1 item' : n + ' items') : n + ' ნივთი'; }
  function img(src, w) { return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function local(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function getState() { try { return JSON.parse(store('ubb') || '{}'); } catch (e) { return {}; } }
  function setState(patch) { var s = getState(); for (var k in patch) s[k] = patch[k]; store('ubb', JSON.stringify(s)); }
  function timeOfDay() { var h = new Date().getHours(); return h < 12 ? T.tod.m : h < 18 ? T.tod.d : T.tod.e; }
  function bankLabel(b) { return BANKS[b] ? (IS_EN ? BANKS[b].name : (b === 'tbc' ? 'თიბისი ბანკი' : 'საქართველოს ბანკი')) : ''; }
  function myTokens() { try { return JSON.parse(local('ubb_receipts') || '[]'); } catch (e) { return []; } }
  function rememberToken(t) { var l = myTokens().filter(function (x) { return x.token !== t.token; }); l.push(t); local('ubb_receipts', JSON.stringify(l.slice(-5))); }
  function getCart() { return fetch(ROOT + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }); }
  function api(body) {
    return fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { j.__status = r.status; return j; }); });
  }

  /* Bob — a cheerful little kitchen sponge (soap-bubble mascot). */
  var AVATAR = '<svg viewBox="0 0 64 64" aria-hidden="true"><circle cx="32" cy="32" r="32" fill="#cfe9ff"/><circle cx="12" cy="14" r="3" fill="#fff" opacity=".8"/><circle cx="54" cy="20" r="2" fill="#fff" opacity=".8"/><circle cx="50" cy="9" r="1.4" fill="#fff" opacity=".8"/><path d="M12 48h40v10H12z" fill="#fff"/><path d="M12 48h40v4H12z" fill="#f2f2f2"/><path d="M29 48h6l-3 8z" fill="#d9302c"/><rect x="10" y="7" width="44" height="42" rx="7" fill="#f4d43b"/><path d="M10 14c0-3.9 3.1-7 7-7h30c3.9 0 7 3.1 7 7v3c-3 1-4 4-2 6s3 6 0 8-2 6 0 8 1 6-2 7H17c-3-1-4-5-2-7s3-6 0-8-2-6 0-8 1-5-2-6z" fill="#f8de55"/><g fill="#d9b32a"><circle cx="16" cy="13" r="2.2"/><circle cx="49" cy="12" r="1.8"/><circle cx="50" cy="30" r="2.4"/><circle cx="14" cy="32" r="1.8"/><circle cx="18" cy="44" r="2"/><circle cx="47" cy="44" r="2.2"/><circle cx="32" cy="10" r="1.4"/></g><circle cx="24" cy="25" r="7.5" fill="#fff"/><circle cx="40" cy="25" r="7.5" fill="#fff"/><circle cx="25" cy="26" r="3.4" fill="#3b7dd8"/><circle cx="39" cy="26" r="3.4" fill="#3b7dd8"/><circle cx="25.5" cy="26.5" r="1.7" fill="#1e2a25"/><circle cx="39.5" cy="26.5" r="1.7" fill="#1e2a25"/><circle cx="23.8" cy="24.6" r="1" fill="#fff"/><circle cx="37.8" cy="24.6" r="1" fill="#fff"/><circle cx="16.5" cy="35" r="2.6" fill="#f6a5a0" opacity=".85"/><circle cx="47.5" cy="35" r="2.6" fill="#f6a5a0" opacity=".85"/><path d="M22 35q10 9 20 0" fill="#7a2f2a"/><path d="M22 35q10 5 20 0z" fill="#e0524d"/><rect x="28.5" y="35.5" width="3.2" height="4.2" rx=".8" fill="#fff"/><rect x="32.3" y="35.5" width="3.2" height="4.2" rx=".8" fill="#fff"/></svg>';

  /* ---- soap bubbles (pure CSS animation; spans get random size / position / timing) ---- */
  function bubbleSpans(n) {
    var h = '';
    for (var i = 0; i < n; i++) {
      var size = 8 + Math.round(Math.random() * 22);
      h += '<i style="left:' + Math.round(Math.random() * 92) + '%;width:' + size + 'px;height:' + size + 'px;animation-duration:' + (9 + Math.random() * 9).toFixed(1) + 's;animation-delay:-' + (Math.random() * 14).toFixed(1) + 's"></i>';
    }
    return h;
  }
  function pop(el) {
    /* Little burst of bubbles from an element (add-to-basket, order placed). */
    var box = document.createElement('span');
    box.className = 'ubb__pop';
    var h = '';
    for (var i = 0; i < 7; i++) {
      var a = (i / 7) * Math.PI * 2 + Math.random() * 0.6, r = 26 + Math.random() * 30, sz = 6 + Math.round(Math.random() * 10);
      h += '<i style="--x:' + Math.round(Math.cos(a) * r) + 'px;--y:' + Math.round(Math.sin(a) * r - 18) + 'px;--s:' + sz + 'px;animation-delay:' + Math.round(Math.random() * 120) + 'ms"></i>';
    }
    box.innerHTML = h;
    el.appendChild(box);
    setTimeout(function () { box.remove(); }, 1300);
  }

  /* ---- DOM ---- */
  var root, panel, log, launcher, isOpen = false, catalog = null, busy = false;
  var draft = {}; /* details form + chosen payment, kept in memory for the summary */
  var backendOK = null; /* null = unknown, true/false after the ping */
  function pingBackend() {
    if (backendOK !== null) return;
    api({ action: 'ping' }).then(function (r) { backendOK = !!(r && r.ok && r.configured); }).catch(function () {});
  }

  function build() {
    if (root) return;
    root = document.createElement('div');
    root.className = 'ubb';
    root.innerHTML =
      '<button type="button" class="ubb__launch" aria-label="' + esc(NAME) + '">' +
        '<span class="ubb__launch-av">' + AVATAR + '</span>' +
        '<span class="ubb__launch-txt">' + esc(T.launcher) + '</span>' +
        '<span class="ubb__dot" hidden></span>' +
      '</button>' +
      '<div class="ubb__panel" role="dialog" aria-label="' + esc(NAME) + '" hidden>' +
        '<div class="ubb__bubbles" aria-hidden="true">' + bubbleSpans(9) + '</div>' +
        '<div class="ubb__head">' +
          '<span class="ubb__av">' + AVATAR + '</span>' +
          '<div class="ubb__who"><b>' + esc(NAME) + '</b><span><i></i>' + esc(T.tagline) + '</span></div>' +
          '<button type="button" class="ubb__close" aria-label="' + esc(T.close) + '">&times;</button>' +
        '</div>' +
        '<div class="ubb__log" aria-live="polite"></div>' +
        '<div class="ubb__foot">' + esc(IS_EN ? 'Tap a button to reply · ' : 'პასუხისთვის დააჭირე ღილაკს · ') + '<a href="' + WA + '" target="_blank" rel="noopener">WhatsApp</a></div>' +
      '</div>';
    document.body.appendChild(root);
    panel = root.querySelector('.ubb__panel');
    log = root.querySelector('.ubb__log');
    launcher = root.querySelector('.ubb__launch');
    launcher.addEventListener('click', function () { isOpen ? close() : open(); });
    root.querySelector('.ubb__close').addEventListener('click', close);
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && isOpen) close(); });
    document.addEventListener('click', function (ev) {
      if (!ev.target.closest('.ubb__picker')) { var o = log.querySelectorAll('.ubb__picker.is-open'); for (var i = 0; i < o.length; i++) o[i].classList.remove('is-open'); }
    });
    log.addEventListener('click', onClick);
    log.addEventListener('change', onChange);
    log.addEventListener('submit', onSubmit);
    pingBackend(); /* warm the ordering backend early so the payment step already knows if it is available */
  }

  function open(silent) {
    build();
    isOpen = true;
    panel.hidden = false;
    root.classList.add('is-open');
    document.body.classList.add('ubb-open');
    launcher.querySelector('.ubb__dot').hidden = true;
    setState({ open: true });
    if (!log.children.length) start(silent);
  }
  function close() {
    if (!root) return;
    isOpen = false;
    root.classList.remove('is-open');
    document.body.classList.remove('ubb-open');
    setTimeout(function () { if (!isOpen) panel.hidden = true; }, 260);
    setState({ open: false });
  }

  /* ---- messages ---- */
  function scroll() { requestAnimationFrame(function () { log.scrollTop = log.scrollHeight; }); }
  function clearChips() { var old = log.querySelectorAll('.ubb__chips, .ubb__cta, .ubb__form, .ubb__upload, .ubb__ask'); for (var i = 0; i < old.length; i++) old[i].classList.add('is-done'); }
  function user(text) {
    clearChips();
    var m = document.createElement('div');
    m.className = 'ubb__msg ubb__msg--me';
    m.innerHTML = '<div class="ubb__bubble">' + esc(text) + '</div>';
    log.appendChild(m);
    scroll();
  }
  function bot(html, cb, delay) {
    var t = document.createElement('div');
    t.className = 'ubb__msg ubb__msg--bot ubb__typing';
    t.innerHTML = '<span class="ubb__mav">' + AVATAR + '</span><div class="ubb__bubble" aria-label="' + esc(T.typing) + '"><i></i><i></i><i></i></div>';
    log.appendChild(t);
    scroll();
    var wait = delay == null ? Math.min(1400, 350 + html.replace(/<[^>]+>/g, '').length * 9) : delay;
    setTimeout(function () {
      t.classList.remove('ubb__typing');
      t.querySelector('.ubb__bubble').innerHTML = html;
      scroll();
      if (cb) cb();
    }, wait);
    return t;
  }
  function block(cls, html) {
    var c = document.createElement('div');
    c.className = cls;
    c.innerHTML = html;
    log.appendChild(c);
    scroll();
    return c;
  }
  function chips(list) {
    var h = '';
    for (var i = 0; i < list.length; i++) {
      var it = list[i];
      h += it.href
        ? '<a class="ubb__chip" href="' + esc(it.href) + '"' + (it.blank ? ' target="_blank" rel="noopener"' : '') + '>' + esc(it.label) + '</a>'
        : '<button type="button" class="ubb__chip' + (it.primary ? ' is-primary' : '') + '" data-act="' + esc(it.act) + '"' + (it.arg ? ' data-arg="' + esc(it.arg) + '"' : '') + '>' + esc(it.label) + '</button>';
    }
    return block('ubb__chips', h);
  }

  /* ---- greeting ---- */
  function homeChips() {
    return [{ label: T.c_start, act: 'start' }, { label: T.c_browse, act: 'browse' }, { label: T.c_info, act: 'info' }, { label: T.c_human, act: 'human' }];
  }
  function cartLines(cart) {
    var h = '<div class="ubb__mini">';
    for (var i = 0; i < cart.items.length && i < 6; i++) {
      var it = cart.items[i];
      h += '<div class="ubb__mini-line">' + (it.image ? '<img src="' + esc(img(it.image, 96)) + '" alt="" width="36" height="36">' : '<span></span>') +
        '<span class="ubb__mini-name">' + esc(it.product_title) + (it.variant_title && it.variant_title !== 'Default Title' ? ' <small>' + esc(it.variant_title) + '</small>' : '') + '</span>' +
        '<span class="ubb__mini-qty">×' + it.quantity + '</span><b>' + money(it.original_line_price) + '</b></div>';
    }
    if (cart.items.length > 6) h += '<div class="ubb__mini-more">+' + (cart.items.length - 6) + '</div>';
    h += '<div class="ubb__mini-sum">' + T.cartSum(items(cart.item_count), money(cart.total_price)) + '</div></div>';
    return h;
  }

  function pendingReceipts() {
    /* Tokens from: ?bob_receipt=…, this device (localStorage), the logged-in customer's orders (theme bridge). */
    var list = [], seen = {};
    function add(t) { if (t && t.token && !seen[t.token]) { seen[t.token] = 1; list.push(t); } }
    var m = location.search.match(/[?&]bob_receipt=([a-f0-9]{20,})/);
    if (m) add({ token: m[1] });
    (BRIDGE.pending || []).forEach(function (p) { if (p && p.token && p.receipt !== 'uploaded') add(p); });
    myTokens().forEach(add);
    return list.slice(0, 3);
  }

  function start(silent) {
    var st = getState();
    var back = !!local('ubb_seen');
    local('ubb_seen', '1');
    var pend = pendingReceipts();
    if (pend.length) {
      /* Check with the backend which ones still need a receipt. */
      Promise.all(pend.map(function (p) { return api({ action: 'status', token: p.token }).catch(function () { return null; }); }))
        .then(function (rs) {
          var open = [];
          rs.forEach(function (r, i) { if (r && r.ok && r.method === 'bank' && !r.receipt_uploaded) open.push({ token: pend[i].token, name: r.order_name, bank: r.bank, total: r.total_tetri }); });
          local('ubb_receipts', JSON.stringify(open));
          if (open.length) {
            draft.order = open[0];
            bot(T.pendingHello(open[0].name, bankLabel(open[0].bank)), function () {
              chips([{ label: T.c_upload, act: 'upnow', primary: true }, { label: T.c_bankAgain, act: 'bankagain' }, { label: T.c_upWa, href: WA, blank: true }, { label: T.c_start, act: 'start' }]);
            });
          } else greet(st, back, silent);
        });
      return;
    }
    greet(st, back, silent);
  }

  function greet(st, back, silent) {
    getCart().catch(function () { return { items: [], item_count: 0, total_price: 0 }; }).then(function (cart) {
      var n = cart.item_count || 0;
      if (st.step === 'picks' && st.need && silent) { bot(T.say[st.need], function () { showPicks(st.need); }, 200); return; }
      if (n > 0) {
        bot((st.sentToCheckout ? T.cartHelloBack : T.cartHello) + cartLines(cart), function () {
          chips([{ label: T.c_checkout, act: 'checkout', primary: true }, { label: T.c_basket, act: 'basket' }, { label: T.c_more, act: 'start' }, { label: T.c_human, act: 'human' }]);
        });
        return;
      }
      bot(T.hello(timeOfDay(), back), function () { chips(homeChips()); });
    });
  }

  /* ---- product picks ---- */
  function askNeed() {
    setState({ step: 'need' });
    bot(T.ask, function () {
      var list = [];
      for (var i = 0; i < NEED_ORDER.length; i++) list.push({ label: T.needs[NEED_ORDER[i]], act: 'need', arg: NEED_ORDER[i] });
      chips(list);
    });
  }
  function loadCatalog() {
    if (catalog) return Promise.resolve(catalog);
    return fetch(ROOT + 'collections/shop/products.json?limit=50', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (d) { catalog = d.products || []; return catalog; });
  }
  function pickFor(need, list) {
    var cfg = NEEDS[need], out = [], seen = {}, i, p;
    function ok(p) { return p && !seen[p.handle] && p.variants.some(function (v) { return v.available; }) && !(cfg.skip && cfg.skip.indexOf(p.handle) > -1); }
    function push(p) { if (ok(p)) { seen[p.handle] = 1; out.push(p); } }
    if (cfg.handles) for (i = 0; i < cfg.handles.length; i++) push(list.filter(function (x) { return x.handle === cfg.handles[i]; })[0]);
    if (cfg.tag) for (i = 0; i < list.length; i++) { p = list[i]; if (p.tags && p.tags.indexOf(cfg.tag) > -1) push(p); }
    if (cfg.all) for (i = 0; i < list.length; i++) push(list[i]);
    return out.slice(0, 6);
  }
  function card(p) {
    var av = p.variants.filter(function (v) { return v.available; });
    var v0 = av[0];
    var image = (v0 && v0.featured_image && v0.featured_image.src) || (p.images && p.images[0] && p.images[0].src) || '';
    var url = ROOT + 'products/' + p.handle;
    var h = '<div class="ubb__card" data-handle="' + esc(p.handle) + '" data-id="' + v0.id + '" data-price="' + esc(v0.price) + '">' +
      '<a class="ubb__card-img" href="' + esc(url) + '">' + (image ? '<img src="' + esc(img(image, 200)) + '" alt="" loading="lazy" width="72" height="72">' : '') + '</a>' +
      '<div class="ubb__card-body">' +
        '<a class="ubb__card-title" href="' + esc(url) + '">' + esc(p.title) + '</a>';
    if (av.length > 1) {
      h += '<div class="ubb__picker"><button type="button" class="ubb__pick" aria-haspopup="listbox" aria-label="' + esc(T.pick) + '"><span>' + esc(v0.title) + '</span><i></i></button><div class="ubb__menu" role="listbox">';
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i];
        h += '<button type="button" class="ubb__opt' + (v.id === v0.id ? ' is-on' : '') + '" role="option" data-id="' + v.id + '" data-price="' + esc(v.price) + '" data-img="' + esc(v.featured_image ? v.featured_image.src : '') + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + (v.available ? '' : ' <s>' + esc(T.soldout) + '</s>') + '</button>';
      }
      h += '</div></div>';
    }
    h += '<div class="ubb__card-row"><b class="ubb__price">' + esc(v0.price) + ' ₾</b>' +
      '<span class="ubb__qty" aria-label="' + esc(T.qty) + '"><button type="button" data-q="-1" aria-label="−">−</button><b>1</b><button type="button" data-q="1" aria-label="+">+</button></span>' +
      '<button type="button" class="ubb__add" data-act="add" data-title="' + esc(p.title) + '">' + esc(T.add) + '</button></div>' +
      '</div></div>';
    return h;
  }
  function showPicks(need) {
    setState({ step: 'picks', need: need });
    var holder = block('ubb__cards is-loading', '<div class="ubb__skel"></div><div class="ubb__skel"></div>');
    loadCatalog().then(function (list) {
      var picks = pickFor(need, list);
      holder.classList.remove('is-loading');
      if (!picks.length) {
        holder.remove();
        bot(T.empty, function () { chips([{ label: T.c_bestsellers, act: 'need', arg: 'best' }, { label: T.c_wa, href: WA, blank: true }, { label: T.c_back, act: 'start' }]); });
        return;
      }
      var h = '';
      for (var i = 0; i < picks.length; i++) h += card(picks[i]);
      var link = NEEDS[need].link;
      if (link) h += '<a class="ubb__all" href="' + ROOT + 'collections/' + link + '">' + esc(T.c_shopAll) + ' →</a>';
      holder.innerHTML = h;
      chips([{ label: T.c_checkout, act: 'checkout' }, { label: T.c_back, act: 'start' }]);
    }).catch(function () {
      holder.remove();
      bot(T.loadFail, function () { chips([{ label: T.c_bestsellers, act: 'need', arg: 'best' }, { label: T.c_back, act: 'start' }]); });
    });
  }
  function syncBubble() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    fetch(ROOT + '?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        if (!s || !s['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
        var fresh = doc.querySelector('.shopify-section');
        if (fresh) bubble.innerHTML = fresh.innerHTML;
      }).catch(function () {});
  }
  /* One status bubble + chip row per card group; re-rendered after every add / quantity change
     so the visitor can keep picking from the same list and always sees a fresh "continue" option. */
  function refreshStatus(holder, cart, html) {
    var old = holder.parentNode.querySelectorAll('[data-status-for]');
    for (var i = 0; i < old.length; i++) old[i].remove();
    var m = bot(html, null, 250);
    m.setAttribute('data-status-for', '1');
    var c = chips([{ label: T.c_continue, act: 'checkout', primary: true }, { label: T.c_basket, act: 'basket' }, { label: T.c_other, act: 'start' }]);
    c.setAttribute('data-status-for', '1');
  }
  function variantQty(cart, id) {
    var n = 0;
    for (var i = 0; i < cart.items.length; i++) if (cart.items[i].variant_id === id) n += cart.items[i].quantity;
    return n;
  }
  /* Set the total quantity of one variant. Shopify can split a variant over several
     lines (automatic "3 for" discounts do that), so we address lines by key. */
  function setVariantQty(cart, id, qty) {
    var lines = cart.items.filter(function (i) { return i.variant_id === id; });
    var opts = { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } };
    if (!lines.length) {
      opts.body = JSON.stringify({ items: [{ id: id, quantity: qty }] });
      return fetch(ROOT + 'cart/add.js', opts);
    }
    var updates = {};
    lines.forEach(function (l, i) { updates[l.key] = i === 0 ? qty : 0; });
    opts.body = JSON.stringify({ updates: updates });
    return fetch(ROOT + 'cart/update.js', opts);
  }
  function addToCart(btn) {
    if (busy) return;
    busy = true;
    var c = btn.closest('.ubb__card'), holder = c.closest('.ubb__cards');
    var id = parseInt(c.getAttribute('data-id'), 10);
    var qty = parseInt(c.querySelector('.ubb__qty b').textContent, 10) || 1;
    btn.disabled = true;
    btn.textContent = '…';
    getCart().then(function (cart) { return setVariantQty(cart, id, variantQty(cart, id) + qty); })
      .then(function (r) { if (!r.ok) throw 0; return getCart(); })
      .then(function (cart) {
        c.setAttribute('data-added', id);
        c.querySelector('.ubb__qty b').textContent = variantQty(cart, id) || qty;
        btn.textContent = T.inBasket;
        btn.classList.add('is-added');
        pop(c);
        syncBubble();
        var left = THRESHOLD - cart.total_price;
        refreshStatus(holder, cart, T.added(items(cart.item_count), money(cart.total_price), left));
      })
      .catch(function () {
        btn.textContent = T.add; btn.disabled = false;
        bot(T.addFail, function () { chips([{ label: T.c_bestsellers, act: 'need', arg: 'best' }, { label: T.c_wa, href: WA, blank: true }]); });
      })
      .then(function () { busy = false; });
  }
  var qtyTimer = null;
  function syncQty(c) {
    /* Card already in the basket: quantity stepper edits the cart line directly. */
    var id = parseInt(c.getAttribute('data-added'), 10);
    var qty = parseInt(c.querySelector('.ubb__qty b').textContent, 10) || 1;
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(function () {
      getCart().then(function (cart) { return setVariantQty(cart, id, qty); })
        .then(function () { return getCart(); })
        .then(function (cart) { syncBubble(); refreshStatus(c.closest('.ubb__cards'), cart, T.updated(items(cart.item_count), money(cart.total_price))); })
        .catch(function () {});
    }, 450);
  }
  function resetCard(c) {
    if (!c.hasAttribute('data-added')) return;
    c.removeAttribute('data-added');
    var b = c.querySelector('.ubb__add');
    b.textContent = T.add; b.disabled = false; b.classList.remove('is-added');
  }
  function showCart() {
    getCart().then(function (cart) {
      if (!cart.item_count) { bot(T.emptyCart, askNeed); return; }
      bot(T.cartTitle + cartLines(cart), function () {
        chips([{ label: T.c_continue, act: 'checkout', primary: true }, { label: T.c_shopping, act: 'start' }, { label: T.c_fullCart, act: 'fullcart' }, { label: T.c_back, act: 'home' }]);
      });
    });
  }

  /* ---- payment ---- */
  function payAsk() {
    getCart().then(function (cart) {
      if (!cart.item_count) { bot(T.emptyCart, askNeed); return; }
      draft.cart = cart;
      setState({ step: 'pay' });
      bot(T.payAsk, function () {
        chips([{ label: T.c_card, act: 'pay', arg: 'card' }, { label: T.c_bank, act: 'pay', arg: 'bank' }, { label: T.c_cash, act: 'pay', arg: 'cash' }]);
      });
    });
  }
  function cardCheckout() {
    var cart = draft.cart;
    var h = '<b>' + T.preTitle + '</b><ol class="ubb__steps">';
    for (var i = 0; i < T.preSteps.length; i++) { var s = T.preSteps[i]; h += '<li><span>' + s[0] + '</span><div><b>' + esc(s[1]) + '</b><small>' + esc(s[2]) + '</small></div></li>'; }
    h += '</ol><small class="ubb__note">' + esc(T.preNote) + '</small>';
    bot(h, function () {
      block('ubb__cta', '<a class="ubb__go" href="' + ROOT + 'checkout">' + esc(T.preBtn) + '</a><div class="ubb__cta-sub">' + items(cart.item_count) + ' · ' + money(cart.total_price) + '</div>');
      chips([{ label: T.c_more, act: 'start' }, { label: T.c_basket, act: 'basket' }]);
      setState({ step: 'checkout', sentToCheckout: true });
    });
  }
  /* ---- details, one question at a time ---- */
  var STEPS = ['name', 'phone', 'region', 'address', 'email', 'note'];
  var OPTIONAL = { email: 1, note: 1 };
  function detailsForm() {
    /* Bob asks for the delivery details one by one (name → phone → region → address → email → note). */
    var d = draft.details || {};
    if (!d.name && BRIDGE.customer && BRIDGE.customer.name) d.name = BRIDGE.customer.name;
    if (!d.email && BRIDGE.customer && BRIDGE.customer.email) d.email = BRIDGE.customer.email;
    draft.details = d;
    draft.step = 0;
    var intro = draft.method === 'cash' ? T.cashIntro : T.bankIntro(bankLabel(draft.bank));
    bot(intro, function () { askStep(); });
  }
  function askStep() {
    var key = STEPS[draft.step];
    if (!key) { summary(); return; }
    var d = draft.details;
    bot(T.q[key], function () {
      if (key === 'region') {
        chips([{ label: T.r_tbilisi, act: 'answer', arg: 'tbilisi', primary: d.region === 'tbilisi' }, { label: T.r_region, act: 'answer', arg: 'region', primary: d.region === 'region' }, { label: T.r_mountain, act: 'answer', arg: 'mountain', primary: d.region === 'mountain' }]);
        return;
      }
      var type = key === 'phone' ? 'tel' : key === 'email' ? 'email' : 'text';
      var ac = { name: 'name', phone: 'tel', address: 'street-address', email: 'email', note: 'off' }[key];
      block('ubb__ask', '<form novalidate><input name="a" type="' + type + '" autocomplete="' + ac + '"' + (type !== 'text' ? ' inputmode="' + type + '"' : '') +
        ' placeholder="' + esc(T.ph[key] || '') + '" value="' + esc(d[key] || '') + '" aria-label="' + esc(T.q[key].replace(/<[^>]+>/g, '')) + '">' +
        '<button type="submit" aria-label="' + esc(T.send) + '">➤</button></form>' +
        (OPTIONAL[key] ? '<button type="button" class="ubb__chip ubb__skip" data-act="answer" data-arg="">' + esc(T.c_skip) + '</button>' : ''));
      var inp = log.querySelector('.ubb__ask:not(.is-done) input');
      if (inp) setTimeout(function () { inp.focus({ preventScroll: true }); scroll(); }, 60);
    }, 350);
  }
  function answer(val) {
    var key = STEPS[draft.step], d = draft.details;
    val = String(val || '').trim();
    if (key === 'phone') {
      if (val.replace(/\D/g, '').length < 9) { bot(T.bad.phone, askStep); return; }
    } else if (key === 'email') {
      if (val && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) { bot(T.bad.email, askStep); return; }
    } else if (!OPTIONAL[key] && key !== 'region' && val.length < 2) { bot(T.bad[key] || T.bad.name, askStep); return; }
    d[key] = val;
    if (key === 'region') user(T['r_' + val]);
    else user(val || T.c_skip);
    draft.step++;
    askStep();
  }
  function summary() {
    var d = draft.details, cart = draft.cart;
    var ship = cart.total_price >= THRESHOLD ? 0 : SHIP[d.region];
    draft.ship = ship;
    var h = '<b>' + esc(T.summaryTitle) + '</b>' + cartLines(cart).replace('<div class="ubb__mini-sum">', '<div class="ubb__mini-sum" hidden>') +
      '<div class="ubb__sum"><div><span>' + esc(T.s_items) + '</span><b>' + money(cart.total_price) + '</b></div>' +
      '<div><span>' + esc(T.s_ship) + '</span><b>' + (ship ? money(ship) : esc(T.s_free)) + '</b></div>' +
      '<div class="ubb__sum-total"><span>' + esc(T.s_total) + '</span><b>' + money(cart.total_price + ship) + '</b></div>' +
      '<div><span>' + esc(T.s_pay) + '</span><b>' + esc(draft.method === 'cash' ? T.m_cash : T.m_bank(bankLabel(draft.bank))) + '</b></div>' +
      '<div class="ubb__sum-addr">📍 ' + esc(d.name) + ' · ' + esc(d.phone) + '<br>' + esc(d.address) + '</div></div>';
    bot(h, function () {
      chips([{ label: T.c_place, act: 'place', primary: true }, { label: T.c_edit, act: 'edit' }]);
    });
  }
  function placeOrder() {
    if (busy) return;
    busy = true;
    var d = draft.details, cart = draft.cart;
    var wait = bot(T.placing, null, 0);
    api({
      action: 'create', locale: IS_EN ? 'en' : 'ka', method: draft.method, bank: draft.bank || null,
      name: d.name, phone: d.phone, email: d.email, address: d.address, region: d.region, note: d.note, website: d.website || '',
      cart_total_tetri: cart.total_price,
      items: cart.items.map(function (i) { return { id: i.variant_id, quantity: i.quantity, title: i.product_title + (i.variant_title && i.variant_title !== 'Default Title' ? ' — ' + i.variant_title : ''), price_tetri: i.final_price }; })
    }).then(function (r) {
      busy = false;
      if (!r.ok) {
        wait.remove();
        if (r.error === 'rate_limited') { bot(T.orderFail, function () { chips([{ label: T.c_wa, href: WA, blank: true }]); }); return; }
        bot(T.orderOffline, handoffCheckout, 300);
        return;
      }
      draft.order = { token: r.token, name: r.order_name, bank: draft.bank, total: r.total_tetri };
      fetch(ROOT + 'cart/clear.js', { method: 'POST', credentials: 'same-origin' }).then(syncBubble).catch(function () {});
      setState({ step: 'done', sentToCheckout: false });
      wait.querySelector('.ubb__bubble').innerHTML = T.placed(r.order_name);
      pop(wait.querySelector('.ubb__bubble'));
      if (draft.method === 'cash') {
        bot(T.placedCash, function () { chips([{ label: T.c_start, act: 'start' }, { label: T.c_human, act: 'human' }]); });
      } else {
        rememberToken(draft.order);
        bot(T.placedBank(bankLabel(draft.bank)), function () { bankCard(draft.order, true); });
      }
    }).catch(function () {
      busy = false; wait.remove();
      bot(T.orderOffline, handoffCheckout, 300);
    });
  }
  /* Fallback when the ordering backend is not available: the order is finished on
     Shopify's own checkout, where the customer picks "Cash on Delivery" (already enabled
     for the store). The chosen method / bank is saved on the cart so it shows up on the
     order in Shopify admin as additional details. */
  function handoffCheckout() {
    var cart = draft.cart, method = draft.method, bank = draft.bank;
    var attrs = { 'Bob': method === 'cash' ? 'Cash on delivery' : 'Bank transfer — ' + (BANKS[bank] ? BANKS[bank].name : '') };
    var d = draft.details;
    var body = { attributes: attrs };
    if (d) {
      attrs['Bob — region'] = d.region;
      if (d.note) body.note = d.note;
    }
    fetch(ROOT + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).catch(function () {});
    setState({ step: 'checkout', sentToCheckout: true });
    var cta = function () {
      block('ubb__cta', '<a class="ubb__go" href="' + ROOT + 'checkout">' + esc(T.preBtn) + '</a><div class="ubb__cta-sub">' + items(cart.item_count) + ' · ' + money(cart.total_price) + '</div>');
      chips([{ label: T.c_more, act: 'start' }, { label: T.c_wa, href: WA, blank: true }]);
    };
    if (method === 'bank') {
      bot(T.handoffBank(bankLabel(bank)), function () {
        bankCard({ bank: bank, name: T.b_purposeOrder, total: 0 }, false);
        cta();
      });
    } else bot(T.handoffCash, cta);
  }
  function bankCard(order, withChips) {
    var b = BANKS[order.bank] || BANKS.tbc;
    block('ubb__bank', '<div class="ubb__bank-head">🏦 ' + esc(b.name) + '</div>' +
      '<div><span>' + esc(T.b_holder) + '</span><b>' + esc(b.holder) + '</b></div>' +
      '<div><span>' + esc(T.b_iban) + '</span><b class="ubb__mono">' + esc(b.iban) + '</b></div>' +
      (order.total ? '<div><span>' + esc(T.b_amount) + '</span><b>' + money(order.total) + '</b></div>' : '') +
      '<div><span>' + esc(T.b_purpose) + '</span><b>' + esc(order.name) + '</b></div>' +
      '<p class="ubb__bank-note">' + esc(T.b_note) + '</p>');
    if (withChips) chips([{ label: T.c_upNow, act: 'upnow', primary: true }, { label: T.c_upLater, act: 'uplater' }, { label: T.c_upWa, href: WA + '?text=' + encodeURIComponent((IS_EN ? 'Receipt for order ' : 'ქვითარი შეკვეთისთვის ') + order.name), blank: true }]);
  }
  function uploadBox() {
    block('ubb__upload', '<label class="ubb__drop"><input type="file" accept="image/*,application/pdf" data-up><span>📎 ' + esc(T.upPick) + '</span></label>');
  }
  function sendReceipt(input) {
    var file = input.files && input.files[0];
    if (!file || busy) return;
    busy = true;
    var box = input.closest('.ubb__upload');
    box.classList.add('is-busy');
    box.querySelector('span').textContent = T.upSending;
    var fd = new FormData();
    fd.append('action', 'upload'); fd.append('token', draft.order.token); fd.append('file', file, file.name || 'receipt.jpg');
    fetch(API, { method: 'POST', body: fd }).then(function (r) { return r.json(); }).then(function (r) {
      busy = false;
      if (!r.ok) throw 0;
      box.classList.add('is-done');
      user('📎 ' + (file.name || 'receipt'));
      local('ubb_receipts', JSON.stringify(myTokens().filter(function (t) { return t.token !== draft.order.token; })));
      bot(T.upDone(r.order_name || draft.order.name), function () { chips([{ label: T.c_start, act: 'start' }, { label: T.c_human, act: 'human' }]); });
    }).catch(function () {
      busy = false;
      box.classList.remove('is-busy');
      box.querySelector('span').textContent = '📎 ' + T.upPick;
      bot(T.upFail, function () { chips([{ label: T.c_upWa, href: WA, blank: true }]); });
    });
  }
  function uploadLater() {
    var o = draft.order;
    var link = location.origin + ROOT + '?bob_receipt=' + o.token;
    var logged = !!(BRIDGE.customer && BRIDGE.customer.id);
    bot(logged ? T.laterLogged(o.name) : T.laterAnon(o.name), function () {
      block('ubb__cta', '<div class="ubb__linkbox"><input readonly value="' + esc(link) + '"><button type="button" class="ubb__chip" data-act="copy">' + esc(T.copyLink) + '</button></div>');
      var list = [];
      if (!logged) list.push({ label: T.c_login, href: ROOT + 'account/login?return_url=' + encodeURIComponent(ROOT + '?bob_receipt=' + o.token), primary: true });
      list.push({ label: T.c_upWa, href: WA, blank: true }, { label: T.c_start, act: 'start' });
      chips(list);
    });
  }

  /* ---- info / human ---- */
  function info() {
    setState({ step: 'info' });
    bot(T.infoTitle, function () {
      chips([{ label: T.c_delivery, act: 'faq', arg: 'delivery' }, { label: T.c_pay, act: 'faq', arg: 'pay' }, { label: T.c_returns, act: 'faq', arg: 'returns' }, { label: T.c_contact, act: 'faq', arg: 'contact' }, { label: T.c_back, act: 'start' }]);
    });
  }
  function openBasket() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) { close(); bubble.click(); return; }
    location.href = ROOT + 'cart';
  }

  /* ---- events ---- */
  function onClick(ev) {
    var q = ev.target.closest('[data-q]');
    if (q) {
      var b = q.parentNode.querySelector('b');
      b.textContent = Math.max(1, Math.min(20, parseInt(b.textContent, 10) + parseInt(q.getAttribute('data-q'), 10)));
      var qc = q.closest('.ubb__card');
      if (qc && qc.hasAttribute('data-added')) syncQty(qc);
      return;
    }
    var pk = ev.target.closest('.ubb__pick');
    if (pk) { var p = pk.parentNode; var was = p.classList.contains('is-open'); var all = log.querySelectorAll('.ubb__picker.is-open'); for (var i = 0; i < all.length; i++) all[i].classList.remove('is-open'); if (!was) p.classList.add('is-open'); return; }
    var opt = ev.target.closest('.ubb__opt');
    if (opt && !opt.disabled) {
      var picker = opt.closest('.ubb__picker'), c = opt.closest('.ubb__card');
      picker.classList.remove('is-open');
      var on = picker.querySelectorAll('.is-on'); for (var j = 0; j < on.length; j++) on[j].classList.remove('is-on');
      opt.classList.add('is-on');
      picker.querySelector('.ubb__pick span').textContent = opt.textContent;
      c.setAttribute('data-id', opt.getAttribute('data-id'));
      resetCard(c);
      c.querySelector('.ubb__price').textContent = opt.getAttribute('data-price') + ' ₾';
      var im = c.querySelector('img'), src = opt.getAttribute('data-img');
      if (im && src) im.src = img(src, 200);
      return;
    }
    var b2 = ev.target.closest('[data-act]');
    if (!b2 || b2.disabled) return;
    var act = b2.getAttribute('data-act'), arg = b2.getAttribute('data-arg');
    if (act === 'add') { addToCart(b2); return; }
    if (act === 'copy') {
      var inp = b2.parentNode.querySelector('input');
      inp.select();
      var done = function () { b2.textContent = T.copied; };
      if (navigator.clipboard) navigator.clipboard.writeText(inp.value).then(done, function () { try { document.execCommand('copy'); done(); } catch (e) {} });
      else { try { document.execCommand('copy'); done(); } catch (e) {} }
      return;
    }
    if (b2.classList.contains('ubb__chip') && act !== 'answer') user(b2.textContent);
    switch (act) {
      case 'start': askNeed(); break;
      case 'browse': setState({ step: 'browse' }); bot(T.browse, function () { setTimeout(close, 1600); }); break;
      case 'need': bot(T.say[arg], function () { showPicks(arg); }); break;
      case 'checkout': payAsk(); break;
      case 'pay':
        draft.method = arg; draft.bank = null;
        if (!draft.cart) { payAsk(); break; }
        if (arg === 'card') cardCheckout();
        else if (arg === 'bank') bot(T.bankAsk, function () { chips([{ label: T.c_tbc, act: 'bank', arg: 'tbc' }, { label: T.c_bog, act: 'bank', arg: 'bog' }]); });
        else detailsForm();
        break;
      case 'bank': draft.bank = arg; detailsForm(); break;
      case 'answer': answer(arg); break;
      case 'edit': detailsForm(); break;
      case 'place': placeOrder(); break;
      case 'upnow': uploadBox(); break;
      case 'uplater': uploadLater(); break;
      case 'bankagain': bankCard(draft.order, true); break;
      case 'basket': showCart(); break;
      case 'fullcart': openBasket(); break;
      case 'home': bot(T.howElse, function () { chips(homeChips()); }); break;
      case 'info': info(); break;
      case 'faq':
        bot(T[arg], function () {
          var list = [];
          if (arg === 'contact' || arg === 'returns') list.push({ label: T.c_wa, href: WA, blank: true });
          list.push({ label: T.c_start, act: 'start' }, { label: T.c_back, act: 'info' });
          chips(list);
        });
        break;
      case 'human':
        setState({ step: 'human' });
        bot(T.human, function () { chips([{ label: T.c_wa, href: WA, blank: true }, { label: '📞 ' + PHONE, href: 'tel:' + PHONE.replace(/\s/g, '') }, { label: T.c_back, act: 'start' }]); });
        break;
    }
  }
  function onChange(ev) {
    if (ev.target.hasAttribute('data-up')) { sendReceipt(ev.target); return; }
    if (ev.target.name === 'region') {
      var rs = ev.target.closest('.ubb__radios').querySelectorAll('.ubb__radio');
      for (var i = 0; i < rs.length; i++) rs[i].classList.toggle('is-on', rs[i].querySelector('input').checked);
    }
  }
  function onSubmit(ev) {
    var f = ev.target;
    if (f.closest('.ubb__ask')) {
      ev.preventDefault();
      var a = f.closest('.ubb__ask');
      if (a.classList.contains('is-done')) return;
      var val = f.elements.a.value;
      var key = STEPS[draft.step];
      if (!val.trim() && !OPTIONAL[key]) { f.elements.a.focus(); return; }
      a.classList.add('is-done');
      answer(val);
      return;
    }
    if (!f.closest('.ubb__form')) return;
    ev.preventDefault();
    var v = function (n) { var el = f.elements[n]; return el ? String(el.value || '').trim() : ''; };
    var d = { name: v('name'), phone: v('phone'), address: v('address'), email: v('email'), note: v('note'), website: v('website'), region: (f.querySelector('input[name="region"]:checked') || {}).value || 'tbilisi' };
    var err = f.querySelector('.ubb__err');
    if (!d.name || d.phone.replace(/\D/g, '').length < 9 || !d.address) { err.hidden = false; return; }
    err.hidden = true;
    draft.details = d;
    f.closest('.ubb__form').classList.add('is-done');
    user(d.name + ' · ' + d.phone + ' · ' + d.address);
    summary();
  }

  /* ---- header language switch ---- */
  function langSwitch() {
    var host = document.querySelector('.header__icons');
    if (!host || document.querySelector('.ubb-lang')) return;
    var p = location.pathname, qs = location.search;
    var toKa = IS_EN ? (p.replace(/^\/en(?=\/|$)/, '') || '/') : p;
    var toEn = IS_EN ? p : '/en' + (p === '/' ? '' : p);
    var el = document.createElement('div');
    el.className = 'ubb-lang';
    el.setAttribute('aria-label', 'Language');
    el.innerHTML = '<a href="' + esc(toKa + qs) + '" hreflang="ka" lang="ka"' + (IS_EN ? '' : ' class="is-on" aria-current="true"') + '>ქარ</a><a href="' + esc(toEn + qs) + '" hreflang="en" lang="en"' + (IS_EN ? ' class="is-on" aria-current="true"' : '') + '>EN</a>';
    host.insertBefore(el, host.firstChild);
  }

  /* ---- boot ---- */
  function boot() {
    build();
    langSwitch();
    var st = getState();
    if (/[?&]bob_receipt=/.test(location.search)) { open(); return; }
    if (st.open) { open(true); return; }
    if (!store('ubb_auto')) {
      store('ubb_auto', '1');
      setTimeout(function () { if (!isOpen) open(); }, 2200);
    } else if (!st.step || st.step === 'browse') {
      launcher.querySelector('.ubb__dot').hidden = false;
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
